var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKitsIconXmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ed1d2b",
    d: "M 375.023438 187.519531 C 375.023438 291.074219 291.074219 375.023438 187.519531 375.023438 C 83.964844 375.023438 0.0195312 291.074219 0.0195312 187.519531 C 0.0195312 83.964844 83.964844 0.0195312 187.519531 0.0195312 C 291.074219 0.0195312 375.023438 83.964844 375.023438 187.519531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 280.019531 95.019531 C 270.957031 85.953125 256.261719 85.953125 247.199219 95.019531 L 187.519531 154.695312 L 127.839844 95.019531 C 118.777344 85.953125 104.082031 85.953125 95.019531 95.019531 C 85.953125 104.082031 85.953125 118.777344 95.019531 127.839844 L 154.695312 187.519531 L 95.019531 247.199219 C 85.953125 256.261719 85.953125 270.957031 95.019531 280.019531 C 104.082031 289.085938 118.777344 289.085938 127.839844 280.019531 L 187.519531 220.34375 L 247.199219 280.019531 C 256.261719 289.085938 270.957031 289.085938 280.019531 280.019531 C 289.085938 270.957031 289.085938 256.261719 280.019531 247.199219 L 220.34375 187.519531 L 280.019531 127.839844 C 289.085938 118.777344 289.085938 104.082031 280.019531 95.019531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitsIconXmark);
export default __webpack_public_path__ + "static/media/kits_icon_xmark.e5f6dbfade4ea0649180b4e8ca136795.svg";
export { ForwardRef as ReactComponent };